import { Injectable } from '@angular/core';
import { IPredmetStavkeFilterDto } from '@kodit/core/data-api';
import { BaseFilterService } from '@kodit/core/services';
import { AdvancedFilterActionData } from '@kodit/core/shared-ui';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RobaFilterService
  implements BaseFilterService<IPredmetStavkeFilterDto> {
  constructor() {}

  advanceFilterSubmitted$ = new BehaviorSubject<
    AdvancedFilterActionData<IPredmetStavkeFilterDto>
  >(null);
  get getAdvanceFilterSubmitted() {
    return this.advanceFilterSubmitted$.asObservable();
  }
  set setAdvanceFilterSubmitted(
    data: AdvancedFilterActionData<IPredmetStavkeFilterDto>
  ) {
    this.advanceFilterSubmitted$.next(data);
  }
}
